import React from 'react';
import PropTypes from 'prop-types';

import './OptionFilters.sass';

import FieldRadioGroupBar from '../fields/fieldRadioGroupBar/FieldRadioGroupBar';

export default class OptionFilters extends React.PureComponent {
  static emptyChoice = [{label: 'Any', code: 0}];

  onChange = (filter, value) => {
    const {values, onChange} = this.props;

    onChange({...values, [filter]: parseInt(value) || undefined});
  };

  render() {
    const {optionGroupId, notEmpty, compact, filters, values} = this.props;

    return (
      <div className="category-filters">
        {filters.map((filter) => {
          let name = 'filter_';

          if (optionGroupId) {
            name += `${optionGroupId}_`;
          }

          name += filter.id;

          return (
            <div key={filter.id} className="category-filters__filter">
              <FieldRadioGroupBar
                optionGroupId={optionGroupId}
                compact={compact}
                choices={(notEmpty ? [] : OptionFilters.emptyChoice).concat(
                  filter.values.map((value) => ({
                    code: value.id,
                    label: value.value,
                  }))
                )}
                input={{
                  name,
                  value: values[filter.id] || 0,
                  onChange: (evt) => this.onChange(filter.id, evt.target.value),
                }}
              />
            </div>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/optionFilters/OptionFilters.js